<template>
  <div class="About">
    <h2>锦龙名车中心</h2>
    <div class="container">
      <div v-if="position == 2">
        <img src="../../images/about_sz.jpg"/>
        <p>
         「锦龙易手车」凭借多年的经验，拥有一批资深的评估师及销售顾问。
          同时，利用集团的优势，统一对车辆资源进行整合，满足不同地区不同消费群体的需求。
        <br/>
          其服务包括：免费评价检测、车辆收购、美容整备、易手车销售、车辆保用、售后服务、按揭贷款等。
          展望未来，「锦龙易手车」将继续本着「诚信、责任、优质」的宗旨，为客户提供至臻完美的汽车服务。
        <p>地址：深圳市南山区招商街道蛇口港湾大道26号A3</p>
        <p>电话：0755-26808950</p>
        <p>服务：车辆免费评价、车辆收购、整备翻新、新旧车置换、销售、寄售、过户、按揭贷款</p>
        <p>营业时间：09:00-18:00</p>
        <div class="map-tt">
          <h3>锦龙汽车集团旗下深圳区五家二手车展厅陈列室</h3>
          <ul>
            <li v-for="(item, index) in map" :key="index">
              <div class="map">
                <div class="info">点击地图上的点标记，打开详细信息</div>
                <div :id="item.container" class="map-amap"></div>
              </div>
              <span>{{item.infoTitle}}</span>
              <span>联系方式：{{item.infoBody2}}</span>
              <span>营业时间：{{item.time}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="position == 1">
        <img src="../../images/about_gz.jpg"/>
        <p>
          「锦龙易手车」品牌创立于2009年，是锦龙汽车集团旗下一个全新的子品牌，从2004年经营奥迪二手车至今，集团旗下各4S店（宾利、阿斯顿马丁、兰博基尼、保时捷、奔驰、奥迪、现代、起亚）都相继开展了二手车收购、置换、销售业务。而「锦龙易手车」自用集团的优势，统一对车辆资源进行整合，制定统一的车辆检测标准和流程，向客户提供公平、透明的估价，并进行标准化的易手车整备各质量认证，为客户提供值得信任的产品，满足不同地区不同消费群体的要求。
          <br/><br/>
          凭着多年的经验，拥用一批资深的评价技师及销售顾问，无论在车辆鉴定、评价流程、整备质量等方面都赢得了顾客的好评。多年来，「锦龙易手车」在集团及各子公司的共同努力下，已在市场上树立了一定的品牌知名度，目前发展状况良好，规模不断扩大。
          <br/><br/>
          展望未来，「锦龙易手车」将继续以「诚信、责任、优质」的宗旨，为客户提供至臻完美的汽车服务。
          <br/><br/>
          「锦龙易手车」至臻服务
        </p>
        <p>地址：广州市天河区奥体南路5号</p>
        <p>电话：020-85292590</p>
        <p>服务：车辆免费评价、车辆收购、整备翻新、新旧车置换、销售、寄售、过户、按揭贷款</p>
        <p>营业时间：09:00-18:00</p>
        <div class="map-tt">
          <h3>锦龙汽车集团于2004年开始在广州地区开设多家全新的二手车展厅：</h3>
          <ul>
            <li v-for="(item, index) in mapgz" :key="index">
              <div class="map">
                <div class="info">点击地图上的点标记，打开详细信息</div>
                <div :id="item.container" class="map-amap"></div>
              </div>
              <span>{{item.infoTitle}}</span>
              <!-- <span>联系方式：{{item.infoBody2}}</span> -->
              <!-- <span>营业时间：{{item.time}}</span> -->
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PubSub from 'pubsub-js'
import MapLoader from '../../js/AMap.js'
import Cookies from 'js-cookie'
import AMapUI from 'AMapUI'

export default {
  name: 'AboutD',
  data () {
    return {
      position: Cookies.get('position') || 2,
      tabPosition: 'left',
      map: [
        {container: 'container1', id: 1, position1: 113.887426, position2: 22.50748, infoTitle: '深圳锦龙汽车资易有限公司', infoBody1: '深圳市南山区月亮湾大道港城路平方汽车园奥德大楼', infoBody2: '0755-26830000', href: 'http://f.amap.com/wo2Z_0286lZM', time:'9:00-18:00'},
        {container: 'container2', id: 2, position1: 114.233178, position2: 22.734019, infoTitle: '深圳锦奥汽车贸易有限公司', infoBody1: '深圳市龙岗区回龙路200号', infoBody2: '0755-21620000', href: 'http://f.amap.com/57btV_0EC6RYO', time:'9:00-18:00'},
        {container: 'container3', id: 3, position1: 114.139816, position2: 22.542261, infoTitle: '深圳奥德汽车贸易有限公司', infoBody1: '深圳市罗湖区延芳路口东益华鹏汽车交易广场E3', infoBody2: '0755-25110000', href: 'http://f.amap.com/54HKl_0AF6SrH', time:'9:00-18:00'},
        {container: 'container4', id: 4, position1: 113.906411, position2: 22.476232, infoTitle: '深圳德迪汽车贸易有限公司', infoBody1: '深圳市南山区蛇口港湾大道26号A2', infoBody2: '0755-88272888', href: 'http://f.amap.com/2HItO_0136SDJ', time:'9:00-18:00'}
      ],
      mapgz: [
        {container: 'container1', id: 1, position1: 113.371672, position2: 22.960846, infoTitle: '广州锦龙名车城-二手车交易中心', infoBody1: '广州市番禺区东环街道东环街蔡二村大北路552-101号', infoBody2: '020-85292590', href: 'http://surl.amap.com/2rJ55_0977Cwk', time:'9:00-18:00'},
        {container: 'container2', id: 2, position1: 113.373022, position2: 23.140692, infoTitle: '广州锦龙平行进口名车交易中心', infoBody1: '广州市天河区博汇街3号', infoBody2: '020-85292590', href: 'http://surl.amap.com/372Pf_01D7Crl', time:'9:00-18:00'},
        {container: 'container3', id: 3, position1: 113.413921, position2: 23.133645, infoTitle: '广州锦盈二手车交易中心', infoBody1: '广州市天河区奥体南路5号', infoBody2: '020-85292590', href: 'http://surl.amap.com/6gllJ_0927CED', time:'9:00-18:00'},
        {container: 'container4', id: 4, position1: 113.41255, position2: 23.134737, infoTitle: '广州锦龙二手车展厅', infoBody1: '广州市天河区奥体路55号', infoBody2: '020-85292590', href: 'http://surl.amap.com/19gUh_0A27CzZ', time:'9:00-18:00'},
        {container: 'container5', id: 5, position1: 113.412587, position2: 23.135512, infoTitle: '广州锦众二手车展厅', infoBody1: '广州市天河区奥体路53号', infoBody2: '020-85292590', href: 'http://surl.amap.com/6q01i_01F33nU', time:'9:00-18:00'},
        {container: 'container6', id: 6, position1: 113.524284, position2: 22.820313, infoTitle: '广州德迪二手车展厅', infoBody1: '广州市南沙区黄阁镇东泽一路1号', infoBody2: '020-85292590', href: 'http://surl.amap.com/4vEy8_0EA7CSK', time:'9:00-18:00'},
        {container: 'container7', id: 7, position1: 113.445714, position2: 23.14141, infoTitle: '广州锦星行二手车展厅', infoBody1: '广州市黄埔区科学城科林路18号', infoBody2: '020-85292590', href: 'http://surl.amap.com/6iQNA_0027Cv2', time:'9:00-18:00'}
        ] 
    }
  },
  methods: {
  },
  mounted () {
    let that = this
    if(that.position == 1){
      that.mapgz.forEach(i => {
        // console.info(i)
        MapLoader().then(AMap => {
          console.log('地图加载成功',i.id)
          let map = new AMap.Map(i.container, {
            resizeEnable: true,
            // dragEnable: false, 禁止拖动
            zoomEnable: true,  //禁止缩放
            zoom: 16,
            center: [i.position1, i.position2]
          })
          AMap.plugin('AMap.Marker', function () {
            let marker = new AMap.Marker({
              map: map,
              position: new AMap.LngLat(i.position1, i.position2)
            })
            AMap.event.addListener(marker, 'click', (e) => {
              AMapUI.loadUI(['overlay/SimpleInfoWindow'], function (SimpleInfoWindow) {
                var infoWindow = new SimpleInfoWindow({
                  infoTitle: '<strong style="font-size: 14px">'+ i.infoTitle +'</strong>',
                  infoBody: '<div style="width: 200px;line-height: 16px;font-size: 12px;"><p>地址：'+ i.infoBody1 +'</p><p>联系电话：'+ i.infoBody2 +'</p><p>营业时间：'+ i.time +'</p><p style="text-align:right; "><a style="color: red" href="'+ i.href +'">导航到店</a></p></div>',
                  offset: new AMap.Pixel(0, -20),
                  autoMove: true,
                  isCustom: true
                })
                infoWindow.open(map, e.target.getPosition()) 
                // 最坑的就是这一步了，他的infowindow没有点击事件，所以infoWindow.get$Container()会返回这个infowindow（jquery）对象
                // let infoEle = infoWindow.get$Container()
                //给infowindow添加点击事件，并在回调函数中处理业务或者跳转等
                // infoEle.on('click', (e) => {
                //   router.push({name: 'proinfo', params: 'http://www.kamlung.com/'})
                // })
              })
            })
          })
        })
      })
    } else {
      that.map.forEach(i => {
        // console.info(i)
        MapLoader().then(AMap => {
          console.log('地图加载成功',i.id)
          let map = new AMap.Map(i.container, {
            resizeEnable: true,
            // dragEnable: false, 禁止拖动
            zoomEnable: true,  //禁止缩放
            zoom: 16,
            center: [i.position1, i.position2]
          })
          AMap.plugin('AMap.Marker', function () {
            let marker = new AMap.Marker({
              map: map,
              position: new AMap.LngLat(i.position1, i.position2)
            })
            AMap.event.addListener(marker, 'click', (e) => {
              AMapUI.loadUI(['overlay/SimpleInfoWindow'], function (SimpleInfoWindow) {
                var infoWindow = new SimpleInfoWindow({
                  infoTitle: '<strong style="font-size: 14px">'+ i.infoTitle +'</strong>',
                  infoBody: '<div style="width: 200px;line-height: 16px;font-size: 12px;"><p>地址：'+ i.infoBody1 +'</p><p>联系电话：'+ i.infoBody2 +'</p><p>营业时间：'+ i.time +'</p><p style="text-align:right; "><a style="color: red" href="'+ i.href +'">导航到店</a></p></div>',
                  offset: new AMap.Pixel(0, -20),
                  autoMove: true,
                  isCustom: true
                })
                infoWindow.open(map, e.target.getPosition()) 
                // 最坑的就是这一步了，他的infowindow没有点击事件，所以infoWindow.get$Container()会返回这个infowindow（jquery）对象
                // let infoEle = infoWindow.get$Container()
                //给infowindow添加点击事件，并在回调函数中处理业务或者跳转等
                // infoEle.on('click', (e) => {
                //   router.push({name: 'proinfo', params: 'http://www.kamlung.com/'})
                // })
              })
            })
          })
        })
      })
    }
  },
  components: {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../css-styl/mixins.styl'

  .About
    h2
      font-size 24px
      font-weight 600
      padding 20px 14px 14px
      border-bottom 1px solid #e4e4e4
    .container
      font-size 16px
      text-align center
      margin 40px 0
      img 
        width 100%
        box-shadow 0px 0px 2px #999
      p
        text-align left 
        padding 10px
        line-height 22px
      .map-tt
        h3
          font-size 20px
          text-align left
          padding 10px
          margin 20px
          border-bottom 1px solid #333
        ul
          width 100%
          li
            width 50%
            margin 10px 0
            float left
            span
              width 100%
              display inline-block
              margin-top 8px
              // text-align left
            .map
              color #000
              position relative
              display inline-block
              .info
                font-size 12px
                display block
                padding 6px 16px
                border-radius 1px
                background-color: white
                border-width: 0
                box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5)
                position: absolute
                top: 4px
                right: 4px
                z-index 999
              .map-amap
                width 400px
                height 200px
                position relative
                top 0px
                left 0px
                z-index 99
  @media screen and (min-width: 997px) and (max-width: 1160px)
    .About .container .map-tt ul li .map .map-amap
      width 340px
      height 180px
  @media screen and (min-width: 860px) and (max-width: 996px)
    .About .container .map-tt ul li .map .map-amap
      width 300px
      height 170px
  @media screen and (min-width: 800px) and (max-width: 859px)
    .About .container .map-tt ul li .map .map-amap
      width 280px
      height 140px
  @media screen and (min-width: 100px) and (max-width: 859px)
    .About .container .map-tt ul li 
      width 100%
      .map .map-amap
        width 500px
        height 300px
  @media screen and (min-width: 100px) and (max-width: 599px)
    .About .container .map-tt ul li 
      .map .map-amap
        width 400px
        height 200px
  @media screen and (min-width: 100px) and (max-width: 440px)
    .About .container 
      font-size 14px
      margin 20px 0
      .map-tt 
        h3
          margin 0
          font-size 18px
        ul li .map .map-amap
            width 300px
            height 180px
</style>



// WEBPACK FOOTER //
// src/pages/aboutpages/AboutD.vue